import { observer } from "mobx-react";
import { useParams } from "react-router-dom";
import { useCurrentOrganisationId } from "../../../../../../../../services/local/organisationContext/OrganisationContextModel";
import { useState } from "react";
import { AudiencesGridModalView } from "../../../AudiencesGrid/modals/AudiencesGridModal/AudiencesGridModal_view";
import { ActionAudiencesLinkModalModel } from "./ActionAudienceLinkModal_model";
interface ActionAudiencesLinkModalViewProps {
  itemIds: number[];
  selectedLinkItemIds: number[];
}
const ActionAudiencesLinkModalView: React.FunctionComponent<ActionAudiencesLinkModalViewProps> = observer(
  ({ itemIds, selectedLinkItemIds }) => {
    const { projectId } = useParams<{ projectId: string }>();
    const organisationId = useCurrentOrganisationId();
    const [model] = useState(() => new ActionAudiencesLinkModalModel(+organisationId, +projectId, itemIds));

    return (
      <AudiencesGridModalView
        itemIds={itemIds}
        selectedLinkItemIds={selectedLinkItemIds}
        onAssignSuccess={model.onAssignSuccess}
      ></AudiencesGridModalView>
    );
  }
);

export { ActionAudiencesLinkModalView };
